import { render, staticRenderFns } from "./BaseRequestChanges.vue?vue&type=template&id=12a11480&scoped=true&"
import script from "./BaseRequestChanges.vue?vue&type=script&lang=js&"
export * from "./BaseRequestChanges.vue?vue&type=script&lang=js&"
import style0 from "./BaseRequestChanges.vue?vue&type=style&index=0&id=12a11480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a11480",
  null
  
)

export default component.exports